import Header from './Header';
import Financing from '../financing/Financing';

function LayoutFinancing() {
  return (
    <>
      <Header />
      <Financing />
    </>
  );
}

export default LayoutFinancing;
